import React from 'react';
import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { useForm } from 'react-hook-form';

export type ProvisionAttendueType = {
    provision: number;
    onUpdate: (amount: number) => void;
};

const ProvisionAttendue: React.FunctionComponent<ProvisionAttendueType> = function (props) {
    const { provision, onUpdate } = props;

    type ProvisionAttendueFormObject = {
        montant: string;
    };

    const defaultProvisionAttendue: Partial<ProvisionAttendueFormObject> = {
        montant: (Math.floor(provision * 100) / 100).toFixed(2),
    };

    const formStructure: FormStructure[] = [
        {
            type: 'header',
            label: 'Modifier la provision attendue',
            name: 'main_informations',
        },
        {
            type: 'number',
            inputProps: {
                step: 1,
                min: 0,
            },
            onFocus: (e: React.FocusEvent<HTMLInputElement>) => {
                if (Number(e.target.value) === 0) {
                    // eslint-disable-next-line no-param-reassign
                    e.target.value = '';
                }
            },
            name: 'montant',
            inputlabel: 'Montant',
            placeholder: 'Montant',
            rules: {
                required: 'Vous devez renseigner un montant',
            },
            xs: 12,
            sm: 6,
            md: 3,
            lg: 3,
        },
    ];

    const formContext = useForm({
        mode: 'onTouched',
        defaultValues: defaultProvisionAttendue,
    });

    const onSubmit = async () => {
        const amount = formContext.getValues().montant as unknown as number;

        onUpdate(Number(amount));
    };

    const formProps = {
        formContext,
        onSubmit,
        formObject: {},
    };

    return (
        <FlexyForm
            formStructure={formStructure}
            {...formProps}
        />
    );
};

export default ProvisionAttendue;
